// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-tabs--border-card > .el-tabs__content {\n  padding-top: 0px !important;\n  padding-bottom: 0px !important;\n  overflow: auto !important;\n}\n.el-tab-pane {\n  height: 100vh;\n  overflow: auto !important;\n  overflow-y: auto !important;\n}", ""]);
// Exports
module.exports = exports;
